exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "@media (max-width:770px){.YTKwE{text-align:center!important}}._1FVs3{background-color:#e4002b;color:#fff}._3R1Rs{margin-left:25px}", ""]);

// exports
exports.locals = {
	"textMediaCenter": "YTKwE",
	"loadButton": "_1FVs3",
	"spanAlert": "_3R1Rs"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"importLoaders":1,"sourceMap":false,"modules":true,"localIdentName":"[hash:base64:5]","minimize":true,"discardComments":{"removeAll":true}}!./node_modules/postcss-loader/lib?{"config":{"path":"./tools/postcss.config.js"}}!./src/components/Telemedicina/TurnosSolicitud/TurnosSolicitud.css
// module id = 1306
// module chunks = 0 1